// source: pbtypes/vehicle/infrastructure/flight_deck/software_update.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_first_boot_flasher_status_pb = require('../../../../pbtypes/gen/first_boot/flasher_status_pb.js');
goog.object.extend(proto, pbtypes_gen_first_boot_flasher_status_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
goog.exportSymbol('proto.flight_deck.FirstBootProgress', null, global);
goog.exportSymbol('proto.flight_deck.SoftwareUpdateCheckRequest', null, global);
goog.exportSymbol('proto.flight_deck.SoftwareUpdateErrorState', null, global);
goog.exportSymbol('proto.flight_deck.SoftwareUpdateRequest', null, global);
goog.exportSymbol('proto.flight_deck.SoftwareUpdateStatus', null, global);
goog.exportSymbol('proto.flight_deck.SoftwareUpdateStatus.DiskState', null, global);
goog.exportSymbol('proto.flight_deck.SoftwareUpdateStatus.State', null, global);
goog.exportSymbol('proto.flight_deck.SoftwareUpdateTargetInfo', null, global);
goog.exportSymbol('proto.flight_deck.UbootCounters', null, global);
goog.exportSymbol('proto.flight_deck.UbootStats', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.SoftwareUpdateStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.SoftwareUpdateStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.SoftwareUpdateStatus.displayName = 'proto.flight_deck.SoftwareUpdateStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.SoftwareUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.SoftwareUpdateRequest.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.SoftwareUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.SoftwareUpdateRequest.displayName = 'proto.flight_deck.SoftwareUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.SoftwareUpdateCheckRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.SoftwareUpdateCheckRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.SoftwareUpdateCheckRequest.displayName = 'proto.flight_deck.SoftwareUpdateCheckRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FirstBootProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.FirstBootProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FirstBootProgress.displayName = 'proto.flight_deck.FirstBootProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.UbootCounters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.UbootCounters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.UbootCounters.displayName = 'proto.flight_deck.UbootCounters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.UbootStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.UbootStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.UbootStats.displayName = 'proto.flight_deck.UbootStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.SoftwareUpdateTargetInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.SoftwareUpdateTargetInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.SoftwareUpdateTargetInfo.displayName = 'proto.flight_deck.SoftwareUpdateTargetInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.SoftwareUpdateErrorState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.SoftwareUpdateErrorState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.SoftwareUpdateErrorState.displayName = 'proto.flight_deck.SoftwareUpdateErrorState';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.SoftwareUpdateStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.SoftwareUpdateStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
runningReleaseKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
updateFileReleaseKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
state: jspb.Message.getFieldWithDefault(msg, 3, 0),
batteryLow: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
diskState: jspb.Message.getFieldWithDefault(msg, 5, 0),
finalizingUpdate: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
finalizingProgress: (f = msg.getFinalizingProgress()) && proto.flight_deck.FirstBootProgress.toObject(includeInstance, f),
otaRelatedMetadata: jspb.Message.getFieldWithDefault(msg, 12, ""),
applyProgress: (f = msg.getApplyProgress()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
failedPartitionTargetInfo: (f = msg.getFailedPartitionTargetInfo()) && proto.flight_deck.SoftwareUpdateTargetInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.SoftwareUpdateStatus}
 */
proto.flight_deck.SoftwareUpdateStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.SoftwareUpdateStatus;
  return proto.flight_deck.SoftwareUpdateStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.SoftwareUpdateStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.SoftwareUpdateStatus}
 */
proto.flight_deck.SoftwareUpdateStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRunningReleaseKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUpdateFileReleaseKey(value);
      break;
    case 3:
      var value = /** @type {!proto.flight_deck.SoftwareUpdateStatus.State} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryLow(value);
      break;
    case 5:
      var value = /** @type {!proto.flight_deck.SoftwareUpdateStatus.DiskState} */ (reader.readEnum());
      msg.setDiskState(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinalizingUpdate(value);
      break;
    case 7:
      var value = new proto.flight_deck.FirstBootProgress;
      reader.readMessage(value,proto.flight_deck.FirstBootProgress.deserializeBinaryFromReader);
      msg.setFinalizingProgress(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOtaRelatedMetadata(value);
      break;
    case 10:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setApplyProgress(value);
      break;
    case 11:
      var value = new proto.flight_deck.SoftwareUpdateTargetInfo;
      reader.readMessage(value,proto.flight_deck.SoftwareUpdateTargetInfo.deserializeBinaryFromReader);
      msg.setFailedPartitionTargetInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.SoftwareUpdateStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.SoftwareUpdateStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRunningReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateFileReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getBatteryLow();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getDiskState();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getFinalizingUpdate();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getFinalizingProgress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.flight_deck.FirstBootProgress.serializeBinaryToWriter
    );
  }
  f = message.getOtaRelatedMetadata();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getApplyProgress();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getFailedPartitionTargetInfo();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.flight_deck.SoftwareUpdateTargetInfo.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.flight_deck.SoftwareUpdateStatus.State = {
  NO_FILE: 0,
  SEARCHING: 5,
  VERIFYING: 1,
  VERIFIED: 2,
  APPLYING: 3,
  REBOOTING: 4,
  APPLIED_WITHOUT_REBOOT: 6,
  ERR_SEARCH_FAILED: 12,
  ERR_VERIFY_FAILED: 10,
  ERR_APPLY_FAILED: 11,
  ERR_NO_SPACE: 13
};

/**
 * @enum {number}
 */
proto.flight_deck.SoftwareUpdateStatus.DiskState = {
  DISK_OTHER: 0,
  DISK_INTERNAL_MOUNT: 1
};

/**
 * optional string running_release_key = 1;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getRunningReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.setRunningReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string update_file_release_key = 2;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getUpdateFileReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.setUpdateFileReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional State state = 3;
 * @return {!proto.flight_deck.SoftwareUpdateStatus.State}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getState = function() {
  return /** @type {!proto.flight_deck.SoftwareUpdateStatus.State} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.flight_deck.SoftwareUpdateStatus.State} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool battery_low = 4;
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getBatteryLow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.setBatteryLow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional DiskState disk_state = 5;
 * @return {!proto.flight_deck.SoftwareUpdateStatus.DiskState}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getDiskState = function() {
  return /** @type {!proto.flight_deck.SoftwareUpdateStatus.DiskState} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.flight_deck.SoftwareUpdateStatus.DiskState} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.setDiskState = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool finalizing_update = 6;
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getFinalizingUpdate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.setFinalizingUpdate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional FirstBootProgress finalizing_progress = 7;
 * @return {?proto.flight_deck.FirstBootProgress}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getFinalizingProgress = function() {
  return /** @type{?proto.flight_deck.FirstBootProgress} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.FirstBootProgress, 7));
};


/**
 * @param {?proto.flight_deck.FirstBootProgress|undefined} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
*/
proto.flight_deck.SoftwareUpdateStatus.prototype.setFinalizingProgress = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.clearFinalizingProgress = function() {
  return this.setFinalizingProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.hasFinalizingProgress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string ota_related_metadata = 12;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getOtaRelatedMetadata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.setOtaRelatedMetadata = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.protobuf.Struct apply_progress = 10;
 * @return {?proto.google.protobuf.Struct}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getApplyProgress = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 10));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
*/
proto.flight_deck.SoftwareUpdateStatus.prototype.setApplyProgress = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.clearApplyProgress = function() {
  return this.setApplyProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.hasApplyProgress = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional SoftwareUpdateTargetInfo failed_partition_target_info = 11;
 * @return {?proto.flight_deck.SoftwareUpdateTargetInfo}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.getFailedPartitionTargetInfo = function() {
  return /** @type{?proto.flight_deck.SoftwareUpdateTargetInfo} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.SoftwareUpdateTargetInfo, 11));
};


/**
 * @param {?proto.flight_deck.SoftwareUpdateTargetInfo|undefined} value
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
*/
proto.flight_deck.SoftwareUpdateStatus.prototype.setFailedPartitionTargetInfo = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.SoftwareUpdateStatus} returns this
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.clearFailedPartitionTargetInfo = function() {
  return this.setFailedPartitionTargetInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateStatus.prototype.hasFailedPartitionTargetInfo = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.SoftwareUpdateRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.SoftwareUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.SoftwareUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
releaseKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
dryRun: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
ignoreBatteryLow: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
skipReboot: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
firstBootOneshot: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
mcusToSkipList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.SoftwareUpdateRequest}
 */
proto.flight_deck.SoftwareUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.SoftwareUpdateRequest;
  return proto.flight_deck.SoftwareUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.SoftwareUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.SoftwareUpdateRequest}
 */
proto.flight_deck.SoftwareUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReleaseKey(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDryRun(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoreBatteryLow(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipReboot(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFirstBootOneshot(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addMcusToSkip(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.SoftwareUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.SoftwareUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDryRun();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIgnoreBatteryLow();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSkipReboot();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFirstBootOneshot();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getMcusToSkipList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional string release_key = 1;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.getReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.setReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool dry_run = 2;
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.getDryRun = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.setDryRun = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool ignore_battery_low = 3;
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.getIgnoreBatteryLow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.setIgnoreBatteryLow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool skip_reboot = 4;
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.getSkipReboot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.setSkipReboot = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool first_boot_oneshot = 5;
 * @return {boolean}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.getFirstBootOneshot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.setFirstBootOneshot = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string mcus_to_skip = 6;
 * @return {!Array<string>}
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.getMcusToSkipList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.setMcusToSkipList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.addMcusToSkip = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.SoftwareUpdateRequest} returns this
 */
proto.flight_deck.SoftwareUpdateRequest.prototype.clearMcusToSkipList = function() {
  return this.setMcusToSkipList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.SoftwareUpdateCheckRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.SoftwareUpdateCheckRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateCheckRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sha1: jspb.Message.getFieldWithDefault(msg, 1, ""),
signature: jspb.Message.getFieldWithDefault(msg, 2, ""),
size: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.SoftwareUpdateCheckRequest}
 */
proto.flight_deck.SoftwareUpdateCheckRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.SoftwareUpdateCheckRequest;
  return proto.flight_deck.SoftwareUpdateCheckRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.SoftwareUpdateCheckRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.SoftwareUpdateCheckRequest}
 */
proto.flight_deck.SoftwareUpdateCheckRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSha1(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSignature(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.SoftwareUpdateCheckRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.SoftwareUpdateCheckRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateCheckRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSha1();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSignature();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string sha1 = 1;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.getSha1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateCheckRequest} returns this
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.setSha1 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string signature = 2;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateCheckRequest} returns this
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.setSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 size = 3;
 * @return {number}
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.SoftwareUpdateCheckRequest} returns this
 */
proto.flight_deck.SoftwareUpdateCheckRequest.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FirstBootProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FirstBootProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FirstBootProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FirstBootProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
mcu: jspb.Message.getFieldWithDefault(msg, 1, ""),
totalProgressPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
firstBootAttemptNum: jspb.Message.getFieldWithDefault(msg, 3, 0),
airhawkFlashStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
gimbalFlashStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
userCameraFlashStatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
escsFlashStatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
skytrainFlashStatus: jspb.Message.getFieldWithDefault(msg, 10, 0),
microhardFlashStatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
groundhawkFlashStatus: jspb.Message.getFieldWithDefault(msg, 12, 0),
ubootStats: (f = msg.getUbootStats()) && proto.flight_deck.UbootStats.toObject(includeInstance, f),
isRebooting: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FirstBootProgress}
 */
proto.flight_deck.FirstBootProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FirstBootProgress;
  return proto.flight_deck.FirstBootProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FirstBootProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FirstBootProgress}
 */
proto.flight_deck.FirstBootProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMcu(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalProgressPercent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFirstBootAttemptNum(value);
      break;
    case 4:
      var value = /** @type {!proto.first_boot.FlasherStatus.Enum} */ (reader.readEnum());
      msg.setAirhawkFlashStatus(value);
      break;
    case 5:
      var value = /** @type {!proto.first_boot.FlasherStatus.Enum} */ (reader.readEnum());
      msg.setGimbalFlashStatus(value);
      break;
    case 6:
      var value = /** @type {!proto.first_boot.FlasherStatus.Enum} */ (reader.readEnum());
      msg.setUserCameraFlashStatus(value);
      break;
    case 9:
      var value = /** @type {!proto.first_boot.FlasherStatus.Enum} */ (reader.readEnum());
      msg.setEscsFlashStatus(value);
      break;
    case 10:
      var value = /** @type {!proto.first_boot.FlasherStatus.Enum} */ (reader.readEnum());
      msg.setSkytrainFlashStatus(value);
      break;
    case 11:
      var value = /** @type {!proto.first_boot.FlasherStatus.Enum} */ (reader.readEnum());
      msg.setMicrohardFlashStatus(value);
      break;
    case 12:
      var value = /** @type {!proto.first_boot.FlasherStatus.Enum} */ (reader.readEnum());
      msg.setGroundhawkFlashStatus(value);
      break;
    case 7:
      var value = new proto.flight_deck.UbootStats;
      reader.readMessage(value,proto.flight_deck.UbootStats.deserializeBinaryFromReader);
      msg.setUbootStats(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRebooting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FirstBootProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FirstBootProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FirstBootProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FirstBootProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMcu();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalProgressPercent();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getFirstBootAttemptNum();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getAirhawkFlashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getGimbalFlashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getUserCameraFlashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getEscsFlashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getSkytrainFlashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getMicrohardFlashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getGroundhawkFlashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getUbootStats();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.flight_deck.UbootStats.serializeBinaryToWriter
    );
  }
  f = message.getIsRebooting();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string mcu = 1;
 * @return {string}
 */
proto.flight_deck.FirstBootProgress.prototype.getMcu = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setMcu = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional float total_progress_percent = 2;
 * @return {number}
 */
proto.flight_deck.FirstBootProgress.prototype.getTotalProgressPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setTotalProgressPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional uint32 first_boot_attempt_num = 3;
 * @return {number}
 */
proto.flight_deck.FirstBootProgress.prototype.getFirstBootAttemptNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setFirstBootAttemptNum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional first_boot.FlasherStatus.Enum airhawk_flash_status = 4;
 * @return {!proto.first_boot.FlasherStatus.Enum}
 */
proto.flight_deck.FirstBootProgress.prototype.getAirhawkFlashStatus = function() {
  return /** @type {!proto.first_boot.FlasherStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.first_boot.FlasherStatus.Enum} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setAirhawkFlashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional first_boot.FlasherStatus.Enum gimbal_flash_status = 5;
 * @return {!proto.first_boot.FlasherStatus.Enum}
 */
proto.flight_deck.FirstBootProgress.prototype.getGimbalFlashStatus = function() {
  return /** @type {!proto.first_boot.FlasherStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.first_boot.FlasherStatus.Enum} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setGimbalFlashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional first_boot.FlasherStatus.Enum user_camera_flash_status = 6;
 * @return {!proto.first_boot.FlasherStatus.Enum}
 */
proto.flight_deck.FirstBootProgress.prototype.getUserCameraFlashStatus = function() {
  return /** @type {!proto.first_boot.FlasherStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.first_boot.FlasherStatus.Enum} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setUserCameraFlashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional first_boot.FlasherStatus.Enum escs_flash_status = 9;
 * @return {!proto.first_boot.FlasherStatus.Enum}
 */
proto.flight_deck.FirstBootProgress.prototype.getEscsFlashStatus = function() {
  return /** @type {!proto.first_boot.FlasherStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.first_boot.FlasherStatus.Enum} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setEscsFlashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional first_boot.FlasherStatus.Enum skytrain_flash_status = 10;
 * @return {!proto.first_boot.FlasherStatus.Enum}
 */
proto.flight_deck.FirstBootProgress.prototype.getSkytrainFlashStatus = function() {
  return /** @type {!proto.first_boot.FlasherStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.first_boot.FlasherStatus.Enum} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setSkytrainFlashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional first_boot.FlasherStatus.Enum microhard_flash_status = 11;
 * @return {!proto.first_boot.FlasherStatus.Enum}
 */
proto.flight_deck.FirstBootProgress.prototype.getMicrohardFlashStatus = function() {
  return /** @type {!proto.first_boot.FlasherStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.first_boot.FlasherStatus.Enum} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setMicrohardFlashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional first_boot.FlasherStatus.Enum groundhawk_flash_status = 12;
 * @return {!proto.first_boot.FlasherStatus.Enum}
 */
proto.flight_deck.FirstBootProgress.prototype.getGroundhawkFlashStatus = function() {
  return /** @type {!proto.first_boot.FlasherStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.first_boot.FlasherStatus.Enum} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setGroundhawkFlashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional UbootStats uboot_stats = 7;
 * @return {?proto.flight_deck.UbootStats}
 */
proto.flight_deck.FirstBootProgress.prototype.getUbootStats = function() {
  return /** @type{?proto.flight_deck.UbootStats} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.UbootStats, 7));
};


/**
 * @param {?proto.flight_deck.UbootStats|undefined} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
*/
proto.flight_deck.FirstBootProgress.prototype.setUbootStats = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.clearUbootStats = function() {
  return this.setUbootStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.FirstBootProgress.prototype.hasUbootStats = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool is_rebooting = 8;
 * @return {boolean}
 */
proto.flight_deck.FirstBootProgress.prototype.getIsRebooting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.FirstBootProgress} returns this
 */
proto.flight_deck.FirstBootProgress.prototype.setIsRebooting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.UbootCounters.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.UbootCounters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.UbootCounters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UbootCounters.toObject = function(includeInstance, msg) {
  var f, obj = {
partitionNum: jspb.Message.getFieldWithDefault(msg, 1, 0),
bootAttempts: jspb.Message.getFieldWithDefault(msg, 2, 0),
bootSuccessCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
flightdeckSuccessCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
isPartitionHealthy: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.UbootCounters}
 */
proto.flight_deck.UbootCounters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.UbootCounters;
  return proto.flight_deck.UbootCounters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.UbootCounters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.UbootCounters}
 */
proto.flight_deck.UbootCounters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPartitionNum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBootAttempts(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBootSuccessCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFlightdeckSuccessCount(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPartitionHealthy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.UbootCounters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.UbootCounters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.UbootCounters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UbootCounters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartitionNum();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getBootAttempts();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBootSuccessCount();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getFlightdeckSuccessCount();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getIsPartitionHealthy();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional uint32 partition_num = 1;
 * @return {number}
 */
proto.flight_deck.UbootCounters.prototype.getPartitionNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UbootCounters} returns this
 */
proto.flight_deck.UbootCounters.prototype.setPartitionNum = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 boot_attempts = 2;
 * @return {number}
 */
proto.flight_deck.UbootCounters.prototype.getBootAttempts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UbootCounters} returns this
 */
proto.flight_deck.UbootCounters.prototype.setBootAttempts = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 boot_success_count = 3;
 * @return {number}
 */
proto.flight_deck.UbootCounters.prototype.getBootSuccessCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UbootCounters} returns this
 */
proto.flight_deck.UbootCounters.prototype.setBootSuccessCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 flightdeck_success_count = 4;
 * @return {number}
 */
proto.flight_deck.UbootCounters.prototype.getFlightdeckSuccessCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UbootCounters} returns this
 */
proto.flight_deck.UbootCounters.prototype.setFlightdeckSuccessCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_partition_healthy = 5;
 * @return {boolean}
 */
proto.flight_deck.UbootCounters.prototype.getIsPartitionHealthy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.UbootCounters} returns this
 */
proto.flight_deck.UbootCounters.prototype.setIsPartitionHealthy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.UbootStats.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.UbootStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.UbootStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UbootStats.toObject = function(includeInstance, msg) {
  var f, obj = {
bootQueue: jspb.Message.getFieldWithDefault(msg, 1, ""),
currentPartition: jspb.Message.getFieldWithDefault(msg, 2, 0),
didBootIntoNewPartition: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
partitionsMap: (f = msg.getPartitionsMap()) ? f.toObject(includeInstance, proto.flight_deck.UbootCounters.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.UbootStats}
 */
proto.flight_deck.UbootStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.UbootStats;
  return proto.flight_deck.UbootStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.UbootStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.UbootStats}
 */
proto.flight_deck.UbootStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBootQueue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCurrentPartition(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDidBootIntoNewPartition(value);
      break;
    case 4:
      var value = msg.getPartitionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.flight_deck.UbootCounters.deserializeBinaryFromReader, 0, new proto.flight_deck.UbootCounters());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.UbootStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.UbootStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.UbootStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UbootStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBootQueue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrentPartition();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getDidBootIntoNewPartition();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getPartitionsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getPartitionsMap(true),
    4,
    writer,
    jspb.BinaryWriter.prototype.writeUint32,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.flight_deck.UbootCounters.serializeBinaryToWriter);
  }
};


/**
 * optional string boot_queue = 1;
 * @return {string}
 */
proto.flight_deck.UbootStats.prototype.getBootQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.UbootStats} returns this
 */
proto.flight_deck.UbootStats.prototype.setBootQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 current_partition = 2;
 * @return {number}
 */
proto.flight_deck.UbootStats.prototype.getCurrentPartition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UbootStats} returns this
 */
proto.flight_deck.UbootStats.prototype.setCurrentPartition = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool did_boot_into_new_partition = 3;
 * @return {boolean}
 */
proto.flight_deck.UbootStats.prototype.getDidBootIntoNewPartition = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.UbootStats} returns this
 */
proto.flight_deck.UbootStats.prototype.setDidBootIntoNewPartition = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * map<uint32, UbootCounters> partitions = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.flight_deck.UbootCounters>}
 */
proto.flight_deck.UbootStats.prototype.getPartitionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.flight_deck.UbootCounters>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.flight_deck.UbootCounters));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.flight_deck.UbootStats} returns this
 */
proto.flight_deck.UbootStats.prototype.clearPartitionsMap = function() {
  this.getPartitionsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.SoftwareUpdateTargetInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.SoftwareUpdateTargetInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateTargetInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
releaseKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
gitCommit: jspb.Message.getFieldWithDefault(msg, 2, ""),
diffpackFromReleaseKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
diffpackFromGitCommit: jspb.Message.getFieldWithDefault(msg, 4, ""),
sha1: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.SoftwareUpdateTargetInfo}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.SoftwareUpdateTargetInfo;
  return proto.flight_deck.SoftwareUpdateTargetInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.SoftwareUpdateTargetInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.SoftwareUpdateTargetInfo}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReleaseKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGitCommit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDiffpackFromReleaseKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDiffpackFromGitCommit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSha1(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.SoftwareUpdateTargetInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.SoftwareUpdateTargetInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateTargetInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGitCommit();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDiffpackFromReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDiffpackFromGitCommit();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSha1();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string release_key = 1;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.getReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateTargetInfo} returns this
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.setReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string git_commit = 2;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.getGitCommit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateTargetInfo} returns this
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.setGitCommit = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string diffpack_from_release_key = 3;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.getDiffpackFromReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateTargetInfo} returns this
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.setDiffpackFromReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string diffpack_from_git_commit = 4;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.getDiffpackFromGitCommit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateTargetInfo} returns this
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.setDiffpackFromGitCommit = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string sha1 = 5;
 * @return {string}
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.getSha1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.SoftwareUpdateTargetInfo} returns this
 */
proto.flight_deck.SoftwareUpdateTargetInfo.prototype.setSha1 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.SoftwareUpdateErrorState.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.SoftwareUpdateErrorState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.SoftwareUpdateErrorState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateErrorState.toObject = function(includeInstance, msg) {
  var f, obj = {
errorState: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.SoftwareUpdateErrorState}
 */
proto.flight_deck.SoftwareUpdateErrorState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.SoftwareUpdateErrorState;
  return proto.flight_deck.SoftwareUpdateErrorState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.SoftwareUpdateErrorState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.SoftwareUpdateErrorState}
 */
proto.flight_deck.SoftwareUpdateErrorState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flight_deck.SoftwareUpdateStatus.State} */ (reader.readEnum());
      msg.setErrorState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.SoftwareUpdateErrorState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.SoftwareUpdateErrorState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.SoftwareUpdateErrorState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.SoftwareUpdateErrorState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional SoftwareUpdateStatus.State error_state = 1;
 * @return {!proto.flight_deck.SoftwareUpdateStatus.State}
 */
proto.flight_deck.SoftwareUpdateErrorState.prototype.getErrorState = function() {
  return /** @type {!proto.flight_deck.SoftwareUpdateStatus.State} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flight_deck.SoftwareUpdateStatus.State} value
 * @return {!proto.flight_deck.SoftwareUpdateErrorState} returns this
 */
proto.flight_deck.SoftwareUpdateErrorState.prototype.setErrorState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


goog.object.extend(exports, proto.flight_deck);
